import { getAavOrders, getAavOrder } from '../../thunk/aavOrders';

export default {
    [getAavOrders.pending as any]: (state: any) => {
        state.status = 'loading';
        state.error = null;
    },
    [getAavOrders.fulfilled as any]: (state: any, action: any) => {
        state.status = 'resolved';
        state.list = action.payload.result || [];
        state.queryParams = {
            ...action.meta.arg,
            page: +action.payload.page,
            limit: +action.payload.perPage,
            total: +action.payload.totalCount,
        };
    },
    [getAavOrders.rejected as any]: (state: any, action: any) => {
        state.status = 'rejected';
        state.error = action.payload;
    },
    [getAavOrder.pending as any]: (state: any) => {
        state.singleStatus = 'loading';
        state.singleError = null;
    },
    [getAavOrder.fulfilled as any]: (state: any, action: any) => {
        state.singleStatus = 'resolved';
        state.singleOrder = action.payload;
    },
    [getAavOrder.rejected as any]: (state: any, action: any) => {
        state.singleStatus = 'rejected';
        state.singleError = action.payload;
    },
};
